import LedgerModuleHost from "../../pages/ledger/LedgerModuleHost";
const ledgerHostRoute = {key:"ledgerHost",path:"/ledger/*",component:LedgerModuleHost,permission:"LEDGER_READ",private:true,layout:"main",icon:"faLink",group:"ledger",order:38};
export default ledgerHostRoute;
